import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Megaphone, X } from "lucide-react";

export default function AnnouncementBar() {
  const [ann, setAnn] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    let alive = true;
    const load = () => api.get("/chat/announcement").then((r) => {
      if (!alive) return;
      const a = r.data;
      setAnn(a);
      if (a) setDismissed(localStorage.getItem(`ann_dismissed_${a.id}`) === "1");
    }).catch(() => {});
    load();
    const t = setInterval(load, 30000);
    window.addEventListener("announcement-changed", load);
    return () => { alive = false; clearInterval(t); window.removeEventListener("announcement-changed", load); };
  }, []);

  if (!ann || dismissed) return null;

  const dismiss = () => { localStorage.setItem(`ann_dismissed_${ann.id}`, "1"); setDismissed(true); };
  const urgent = ann.level === "urgent";

  return (
    <div data-testid="announcement-bar"
      className={`flex items-center gap-3 px-5 py-2.5 text-sm ${urgent ? "bg-red-600 text-white" : "bg-[#B8873A] text-white"}`}>
      <Megaphone className="w-4 h-4 shrink-0" />
      <span className="flex-1 font-medium">{ann.message}</span>
      <button onClick={dismiss} data-testid="announcement-dismiss" className="opacity-80 hover:opacity-100 shrink-0"><X className="w-4 h-4" /></button>
    </div>
  );
}
